import { FETCH_SONGS, SONG_SELECTED } from "./constatnts";
import Shazam from "../API/shazamApi";

// Action Creator
export const selectSong = (song) => {
    // Reaturn an Action
    return {
        type: SONG_SELECTED,
        payload: song
    }
}

export const fetchSongs = () => async ( dispatch ) => {

    const response = await Shazam.get('/songs/list-recommendations');
console.log(response.data.tracks);
    return dispatch({
        type: FETCH_SONGS,
        payload: response.data.tracks
    })
}
